export default class IframeHelper {
    static get IFRAME_PRESETS() {
        const urlPrefixes = {
            controlPanel: {
                local: `http://localhost:8000`,
                domain: window.env.VUE_APP_URLS__CONTROL_PANEL
            },
            account: {
                local: `http://localhost:5423`,
                domain: window.env.VUE_APP_URLS__ACCOUNT
            },
            eyeIntelligence: {
                local: `http://localhost:8079`,
                domain: window.env.VUE_APP_URLS__EYEINTELLIGENCE
            },
            cms: {
                local: `http://localhost:2050`,
                domain: window.env.VUE_APP_URLS__CMS
            },
            player: {
                local: window.env.VUE_APP_URLS__PLAYER,
                domain: window.env.VUE_APP_URLS__PLAYER
            }
        };

        return {
            /*
            General
             */
            'media-preview': {
                glyph: `fas fa-image`,
                icon: `image`,
                title: `Preview|Aperçu`,
                url: `{{url}}`,
                fullscreen: true,
                allowFullscreen: true,
                allowOpenExternal: true,
                noEmbedFlag: true,
                fillHeight: true,
                size: `lg`,
                auth: false
            },
            'account-creation': {
                glyph: `fas fa-user-plus`,
                icon: `user`,
                title: `New User Account|Nouveau compte utilisateur`,
                urlPrefix: urlPrefixes.controlPanel,
                url: `/#/user/create?dealerid={{dealerid}}`,
                fullscreen: true,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `md`
            },
            'account-properties': {
                glyph: `fas fa-user`,
                icon: `user`,
                title: `User Account Properties|Propriétés du compte utilisateur`,
                urlPrefix: urlPrefixes.controlPanel,
                url: `/#/user/{{id}}`,
                fullscreen: true,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `md`
            },
            'ticket-creation': {
                glyph: `fas fa-clipboard-list-check`,
                icon: `clipboard`,
                title: `New Ticket|Nouveau ticket`,
                urlPrefix: urlPrefixes.controlPanel,
                url: `/#/ticket/create?dealerid={{dealerid}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'ticket-properties': {
                glyph: `fas fa-clipboard-list-check`,
                icon: `clipboard`,
                title: `Ticket Properties|Propriétés du ticket`,
                urlPrefix: urlPrefixes.controlPanel,
                url: `/#/ticket/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `lg`
            },
            /*
             ACCOUNTING
             */
            'license-creation': {
                glyph: `fas fa-file-certificate`,
                icon: `certificate`,
                title: `Create License|Créer une licence`,
                urlPrefix: urlPrefixes.account,
                url: `/license/create?dealerid={{dealerid}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `lg`
            },
            'license-properties': {
                glyph: `fas fa-file-certificate`,
                icon: `certificate`,
                title: `License Properties|Détails de la licence`,
                urlPrefix: urlPrefixes.account,
                url: `/license/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `lg`
            },
            'license-package-properties': {
                glyph: `fas fa-file-contract`,
                icon: `invoice`,
                title: `License Package Properties|Détails du package`,
                urlPrefix: urlPrefixes.account,
                url: `/package/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `lg`
            },
            /*
            Loyalty
             */
            'loyalty-receipt': {
                glyph: `fas fa-receipt`,
                icon: `receipt`,
                title: `Receipt Properties|Propriétés du reçu`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/loyalty/receipt/{{id}}`,
                fullscreen: true,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'loyalty-member': {
                glyph: `fas fa-user`,
                icon: `user`,
                title: `Member Properties|Propriétés du membre`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/loyalty/member/{{id}}`,
                fullscreen: true,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            /*
            Digital Signage
             */
            'file-properties': {
                glyph: `fas fa-file-image`,
                icon: `file`,
                title: `File Properties|Propriétés du fichier`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/file/edit/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'folder-properties': {
                glyph: `fas fa-folder`,
                icon: `folder`,
                title: `Folder Properties|Propriétés du dossier`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/folder/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `md`
            },
            'player-creation': {
                glyph: `fas fa-tv`,
                icon: `player-creation`,
                title: `New Player|Nouveau diffuseur`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/player-creation?dealerid={{dealerid}}`,
                fullscreen: false,
                allowFullscreen: true,
                fillHeight: false,
                bodyWidth: `900px`,
                height: `900px`
            },
            'player-properties': {
                glyph: `fas fa-tv`,
                icon: `player`,
                title: `Player Properties|Propriétés du diffuseur`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/player/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'player-preview': {
                glyph: `fas fa-eye`,
                icon: `player`,
                title: `Player Preview|Aperçu du diffuseur`,
                urlPrefix: urlPrefixes.player,
                url: `/?preview=player&id={{id}}&cache=${generateGuid()}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `md`
            },
            'playlist-creation': {
                glyph: `fas fa-clapperboard-play`,
                icon: `playlist-content-creation`,
                title: `New Playlist|Nouvelle liste de lecture`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/playlist-creation?dealerid={{dealerid}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: false,
                fillHeight: false,
                size: `xs`
            },
            'playlist-properties': {
                glyph: `fas fa-clapperboard-play`,
                icon: `playlist-content`,
                title: `Playlist Properties|Propriétés de la liste de lecture`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/playlist/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'widget-creation': {
                glyph: `fas fa-sunny`,
                icon: `widgets/apps`,
                title: `New Widget|Nouveau widget`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/widget-creation/{{type}}/{{id}}`,
                fullscreen: true,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `xl`
            },
            'widget-data-collection-creation': {
                glyph: `fas fa-database`,
                icon: `database-creation`,
                title: `New Widget Data Collection|Nouvelle collection de données pour widget`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/widget-data/collection-creation`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `sm`
            },
            'widget-data-collection-properties': {
                glyph: `fas fa-database`,
                icon: `database`,
                title: `Widget Data Collection Properties|Propriétés de la collection de données`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/digital-signage/widget-data/collection/{{type}}/{{id}}`,
                fullscreen: true,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true
            },
            /*
            WiFi
             */
            'router-creation': {
                glyph: `fas fa-router`,
                icon: `router-creation`,
                title: `New Controller|Nouveau contrôleur`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/wifi/inventory/router-creation?dealerid={{dealerid}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: false,
                size: `sm`
            },
            'router-properties': {
                glyph: `fas fa-router`,
                icon: `router`,
                title: `Router Properties|Propriétés du routeur`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/wifi/inventory/router/{{id}}`,
                fullscreen: true,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'network-equipment-creation': {
                glyph: `fak fa-access-point`,
                icon: `network-ap-creation`,
                title: `New Equipment|Nouvel équipement`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/wifi/inventory/equipment-creation?dealerid={{dealerid}}`,
                fullscreen: false,
                allowFullscreen: true,
                fillHeight: true,
                size: `sm`
            },
            'network-equipment-properties': {
                glyph: `fak fa-access-point`,
                icon: `network-ap`,
                title: `Equipment Properties|Propriétés de l'équipement`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/wifi/inventory/equipment/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'network-configuration': {
                glyph: `fak fa-solid-wifi-gear`,
                icon: `access-point`,
                title: `Network Configuration|Paramètres réseaux`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/wifi/network-configuration/{{dealerid}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'wifi-module': {
                glyph: `fas fa-photo-film`,
                icon: `image`,
                title: `Login Visual|Visuel de connexion`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/wifi/visual/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true,
                size: `lg`
            },
            'wifi-user-profile': {
                glyph: `fas fa-user`,
                icon: `user`,
                title: `WiFi User Profile|Profil utilisateur WiFi`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/wifi/crm/user/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                fillHeight: true,
                size: `lg`
            },
            // CMS Eye-Intelligence
            'map-viewer': {
                glyph: `fas fa-map-location-dot`,
                title: `Map Viewer|Aperçu du plan`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/maps/floor-plan/viewer/{{id}}`,
                fullscreen: true,
                allowOpenExternal: true
            },
            'cms-item-properties': {
                glyph: `fas fa-file-text`,
                title: `Item Properties|Propriétés de l'élément`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/cms/items/{{type}}/{{id}}`,
                fullscreen: true,
                allowOpenExternal: true
            },
            'cms-item-creation': {
                glyph: `fas fa-file-text`,
                title: `Create Item|Créer un élément`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/cms/items/create`,
                fullscreen: true,
                allowOpenExternal: true
            },
            // CMS Editor
            'cms-page-preview': {
                glyph: `fas fa-file-text`,
                title: `Page Preview|Aperçu de la page`,
                urlPrefix: urlPrefixes.cms,
                url: `/cms/preview/website/{{websiteId}}/{{id}}`,
                fullscreen: true,
                allowOpenExternal: true
            },
            'cms-page-creation': {
                glyph: `fas fa-file-circle-plus`,
                title: `New Page|Nouvelle page`,
                urlPrefix: urlPrefixes.cms,
                url: `/cms/editor/website/{{id}}/pages/creation`,
                fullscreen: false,
                allowFullscreen: false,
                fillHeight: true
            },
            'cms-website-creation': {
                glyph: `fas fa-plus`,
                title: `Website Creation|Créer un site`,
                urlPrefix: urlPrefixes.cms,
                url: `/cms/editor/website/creation/{{dealerid}}`,
                fullscreen: false,
                allowFullscreen: false,
                fillHeight: true,
                size: `xs`
            },
            'cms-website-settings': {
                glyph: `fas fa-cog`,
                title: `Website Settings|Paramètres du site`,
                urlPrefix: urlPrefixes.cms,
                url: `/cms/editor/website/{{id}}/settings`,
                fullscreen: false,
                allowFullscreen: false,
                fillHeight: true
            },
            'cms-asset-properties': {
                glyph: `fas fa-file`,
                title: `CMS Asset|Fichier CMS`,
                urlPrefix: urlPrefixes.cms,
                url: `/cms/editor/assets/{{websiteId}}/{{id}}`,
                fullscreen: true,
                allowOpenExternal: true
            },
            'cms-session-report': {
                glyph: `fas fa-list-timeline`,
                title: `Visitors Session Report|Rapport de la session du visiteur`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/cms/session/{{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                fillHeight: true,
                size: `lg`
            },
            'cms-smart-link-creation': {
                glyph: `fas fa-link`,
                icon: `link`,
                title: `Smart Link|Lien intelligent`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/cms/smart-link-creation?id={{id}}`,
                fullscreen: false,
                allowFullscreen: true,
                allowOpenExternal: true,
                fillHeight: true
            },
            'online-store-product-view': {
                glyph: `fas fa-shopping-cart`,
                title: `Product|Produit`,
                urlPrefix: urlPrefixes.controlPanel,
                url: `/#/online-store/product/{{id}}`,
                fillHeight: true,
                allowFullscreen: true
            },
            // IT SYSTEM
            'it-incident-properties': {
                glyph: `fas fa-bell-ring`,
                title: `Incident|Incident`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/it/incident/{{id}}`,
                fullscreen: true,
                allowOpenExternal: true
            },
            'it-system-properties': {
                glyph: `fas fa-sidebar`,
                title: `Service|Service`,
                urlPrefix: urlPrefixes.eyeIntelligence,
                url: `/#/it/system/{{id}}`,
                fullscreen: true,
                allowOpenExternal: true
            }
        }
    }

    static getPreset(name) {
        return this.IFRAME_PRESETS[name];
    }

    static postParentMessage(messageData) {
        let data = {
            type: `e-iframe-dialog`,
            url: document.location.href,
            iframeId: window.frameElement ? window.frameElement.id : window.name
        };
        for (let key in messageData) {
            data[key] = messageData[key];
        }
        if (window.top) {
            window.top.postMessage(data, `*`);
        }
        if (window.opener) {
            window.opener.postMessage(data, `*`);
        }
    }
}
